import React from "react";
import emailjs from 'emailjs-com';


import { Container, Row, Col, Button } from "react-bootstrap";
import myImg from "../../Images/pp-bg.png";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillFacebook,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";



import mansionHome from "../../Images/Project/mansion/mansion-home.JPG";
import mansionApartment from "../../Images/Project/mansion/mansion-apartments.JPG";
import mansionReview from "../../Images/Project/mansion/mansion-review.JPG";
import mansionDashboard from "../../Images/Project/mansion/mansion-dashboard.JPG";

import adventourHome from "../../Images/Project//adventour/adventour-home.JPG";
import adventourLogin from "../../Images/Project//adventour/adventour-login.JPG";
import adventourBooking from "../../Images/Project//adventour/adventour-booking.JPG";
import adventourNews from "../../Images/Project//adventour/adventour-news.JPG";

import shebaHome from "../../Images/Project/sheba/sheba-home.JPG";
import shebaService from "../../Images/Project/sheba/sheba-services.JPG";
import shebaDept from "../../Images/Project/sheba/sheba-serv.JPG";
import shebaForm from "../../Images/Project/sheba/sheba-form.JPG";
import ProjectCard from "../Projects/ProjectCards";
import { Link } from "react-router-dom";

import {
  slideInRight,
  bounceIn,
  slideInLeft,
  slideInUp,
  slideInDown,
} from "react-animations";
import Radium, { StyleRoot } from "radium";

function Home2() {
  const sentEmail = e => {
    e.preventDefault();

    emailjs.sendForm('service_i2iu4b4', 'template_oty9j0n', e.target, 'user_tmhhfCWB1rJGnRM4oK5Oj')
      .then((result) => {
        console.log(result.text);
      }, (error) => {
        console.log(error.text);
      });
    e.target.reset();
    window.confirm('Message Sent Successfully')


  }
  const styles = {
    slideInLeft: {
      animation: "x 3s",
      animationName: Radium.keyframes(slideInLeft, "bounce"),
    },
    slideInUp: {
      animation: "x 3s",
      animationName: Radium.keyframes(slideInUp, "bounce"),
    },
    slideInRight: {
      animation: "x 3s",
      animationName: Radium.keyframes(slideInRight, "bounce"),
    },
    bounceIn: {
      animation: "x 3s",
      animationName: Radium.keyframes(bounceIn, "bounce"),
    },
    slideInDown: {
      animation: "x 3s",
      animationName: Radium.keyframes(slideInDown, "bounce"),
    },
  };
  return (
    <StyleRoot>
      <Container fluid className="home-about-section" id="about">
        <Container>
          <Row>
            <Col md={8} className="home-about-description">
              <br />
              <br />
              <br />
              <p className="home-about-body" style={styles.slideInRight}>
                I am an enthusiastic React Js developer know some framework for the frontend and the backend. I fell in love with programming and I have at least learnt something. I know Basic Python but I am basically a MERN Stack developer.
                <br />

                My field of Interest's are building new &nbsp;

                <b >Web Technologies and Products.</b>
              </p>
            </Col>
            <Col md={4} className="myAvtar">
              <Tilt >
                <img style={styles.slideInLeft} src={myImg} className="img-fluid" alt="avatar" />
              </Tilt>
            </Col>
          </Row>
          <br /><br /><br /><br /><br /><br />
          <Container>
            <h1 className="project-heading">
              Some of My Recent <strong className="purple">Works </strong>
            </h1>

            <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
              <Col md={4} className="project-card">
                <div style={styles.slideInLeft}>

                  <ProjectCard
                    home={mansionHome}
                    about={mansionApartment}
                    manage={mansionReview}
                    add={mansionDashboard}
                    imgPath={mansionHome}
                    isBlog={false}
                    title="Mansion Residence"
                    description="This is a Full-Stack Apartmnet rental website.	Users can Register via Email and can login by using that Email. Users can Rent an apartment and see his/her booking in the dashboard.
                Customize Dashboard for User and Admin.Front-end technology: React js, Material UI,React Router, Firebase. Back-end technology: Node js,Express js, MongoDB"
                    link="https://mansion-residence.web.app/"
                    gitlink='https://github.com/nhnajmul17/Mansion-Client'
                    path='/mansion'

                  />
                </div>
              </Col>

              <Col md={4} className="project-card">
                <div style={styles.slideInUp}>

                  <ProjectCard
                    home={adventourHome}
                    about={adventourNews}
                    manage={adventourLogin}
                    add={adventourBooking}
                    imgPath={adventourHome}
                    isBlog={false}
                    title="Adventour"
                    description="This is an Full-Stack Tour based website users can find the best packages and can book their trip. Fully Responsive Website with Firebase Authentication login (Email, Google) system.
              Users can place a booking and can manage those bookings. Technology: React, Bootstrap, React-Router, MongoDB, Express Js, Firebase Authentication."
                    link="https://adventour-001.web.app/"
                    gitlink='https://github.com/nhnajmul17/Adventour-Client'
                    path='/adventour'
                  />
                </div>
              </Col>

              <Col md={4} className="project-card">
                <div style={styles.slideInRight}>

                  <ProjectCard
                    home={shebaHome}
                    about={shebaService}
                    manage={shebaDept}
                    add={shebaForm}
                    imgPath={shebaHome}
                    isBlog={false}
                    title="Sheba Care"
                    description="This is a Hospital related Website. User can Choice the Medical services that they wants. Users can Login via Google sign, Github and Creating free account with Email. Users can book for a different type of treatment. Technology Used: React, Bootstrap, React-Router, Private Route, Firebase Authentication.
              "
                    link="https://sheba-care.web.app/"
                    gitlink='https://github.com/nhnajmul17/Sheba-Care'
                    path='/sheba'

                  />
                </div>
              </Col>
            </Row>

            <Link to='/project'>
              <Button style={styles.slideInDown} variant='info'>All Projects</Button></Link>
          </Container>
          <br /><br /><br /><br />
          <Container>
            <h1 className="project-heading">
              Contact <strong className="purple">Me </strong>
            </h1>

            <form onSubmit={sentEmail}>
              <input
                className="w-75 input"
                type="text"
                name='name'
                placeholder="Your Name"
                required
                style={styles.slideInLeft}
              />
              <br />
              <input
                type="email"
                className="w-75 input"
                name='email'
                placeholder="Your Email"
                required
                style={styles.slideInRight}
              />
              <br />
              <input
                className="w-75 input-message"
                type="text"
                name='message'
                placeholder="Type your message"
                required
                style={styles.slideInDown}
              />
              <br />
              <button type="submit" className="btn submit-btn input">
                Send
              </button>
            </form>
          </Container>
          <Row>
            <Col md={12} className="home-about-social">
              <h5> Feel free to <span className="purple">connect </span>with me</h5>

              <ul className="home-about-social-links">
                <li className="social-icons">
                  <a
                    href="https://github.com/nhnajmul17"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                  >
                    <AiFillGithub />
                  </a>
                </li>
                <li className="social-icons">
                  <a
                    href="https://twitter.com/nh_najmul17"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                  >
                    <AiOutlineTwitter />
                  </a>
                </li>
                <li className="social-icons">
                  <a
                    href="https://www.linkedin.com/in/nhnajmul/"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour  home-social-icons"
                  >
                    <FaLinkedinIn />
                  </a>
                </li>
                <li className="social-icons">
                  <a
                    href="https://www.facebook.com/najmul.hasan.771/"
                    target="_blank"
                    rel="noreferrer"
                    className="icon-colour home-social-icons"
                  >
                    <AiFillFacebook />
                  </a>
                </li>
              </ul>
            </Col>
          </Row>
        </Container>
      </Container >
    </StyleRoot>
  );
}
export default Home2;
